import React from "react";
import AntdPagination from 'antd/lib/pagination';
import { withError} from '@fishx/tracker';

const Pagination = (props) => <AntdPagination {...props} />
Pagination.displayName = 'Pagination';
export default withError(Pagination);


// WEBPACK FOOTER //
// ./src/components/pagination/index.tsx